<template>
  <div :class="[forConasi ? 'content-layout-conasi' : 'content-layout']">
    <div class="w-100 form-panel">
      <div class="container">
        <!-- E Voucher issue queue list -->
        <div class="row" style="justify-content: center; align-items: center;">
          <div class="col-12 col-md-4 font-size-medium pt-2">
            <label class="color-primary">
              {{ $t('voucherManagement.period') }}
            </label>
            <div style="display: flex; justify-content: space-between;">
              <date-picker
                v-model="startDate"
                :disabled="this.selected == VoucherType.PROMOTION"
                :format="format"
                :placeholder="$t('voucherManagement.chooseDate')"
                style="width: 45%;"
              ></date-picker>
              <date-picker
                v-model="endDate"
                :disabled="this.selected == VoucherType.PROMOTION"
                :format="format"
                :placeholder="$t('voucherManagement.chooseDate')"
                style="width: 45%;"
              ></date-picker>
            </div>
          </div>
          <div class="col-12 col-md-4 font-size-medium pt-2">
            <label class="color-primary">
              {{ $t('lookUpVoucher.supplier') }}
            </label>
            <b-form-select v-model="supplier.id">
               <option
                v-for="(supplier, idx) in supplier.list"
                :key="idx"
                :value="supplier.value">{{ $t(supplier.text) }}</option>
            </b-form-select>
          </div>
          <div class="col-12 col-md-4 font-size-medium pt-3 mt-4 btn-search-mt">
            <!-- Btn search -->
            <div class="col-12 font-size-medium text-left p-0">
              <button
                class="btn bg-button-primary text-white my-sm-0 btn-sm border-white"
                type="submit"
                @click="onSearch"
                style="height: calc(1.5em + .75rem + 2px);"
              >
                {{ $t("common.search") }}
              </button>
            </div>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-12 col-md-12 font-size-medium mb-0">
            <label class="color-primary">
              {{ $t('voucherManagement.table.status') }}
            </label>
          </div>
          <div class="col-6 col-md-2 font-size-medium">
            <button
              :class="['btn text-white my-2 my-sm-0 btn-sm w-100 cursor-pointer', this.selected == VoucherType.VOUCHER_NOT_USE_YET ? 'bg-button-primary' : 'bg-button-outline-primary']"
              type="submit"
              @click="selectBtnStatus(VoucherType.VOUCHER_NOT_USE_YET)"
            >
              {{ $t('evoucher.status.notUseYet') }}
            </button>
          </div>
          <div class="col-6 col-md-2 font-size-medium">
            <button
              :class="['btn text-white my-2 my-sm-0 btn-sm w-100 cursor-pointer', this.selected == VoucherType.VOUCHER_WAITING_USE ? 'bg-button-primary' : 'bg-button-outline-primary']"
              type="submit"
              @click="selectBtnStatus(VoucherType.VOUCHER_WAITING_USE)"
            >
              {{ $t('evoucher.status.waitForConfirm') }}
            </button>
          </div>
          <div class="col-6 col-md-2 font-size-medium">
            <button
              :class="['btn text-white my-2 my-sm-0 btn-sm w-100 cursor-pointer', this.selected == VoucherType.VOUCHER_EXPIRED ? 'bg-button-primary' : 'bg-button-outline-primary']"
              type="submit"
              @click="selectBtnStatus(VoucherType.VOUCHER_EXPIRED)"
            >
              {{ $t('voucherManagement.status.expired') }}
            </button>
          </div>
          <div class="col-6 col-md-2 font-size-medium">
            <button
              :class="['btn text-white my-2 my-sm-0 btn-sm w-100 cursor-pointer', this.selected == VoucherType.VOUCHER_USED ? 'bg-button-primary' : 'bg-button-outline-primary']"
              type="submit"
              @click="selectBtnStatus(VoucherType.VOUCHER_USED)"
            >
              {{ $t('evoucher.status.used') }}
            </button>
          </div>
          <div class="col-6 col-md-2 font-size-medium">
            <button
              :class="['btn text-white my-2 my-sm-0 btn-sm w-100 cursor-pointer', this.selected == VoucherType.VOUCHER_TRANSFERRED ? 'bg-button-primary' : 'bg-button-outline-primary']"
              type="submit"
              @click="selectBtnStatus(VoucherType.VOUCHER_TRANSFERRED)"
            >
              {{ $t('evoucher.status.transferred') }}
            </button>
          </div>
          <!-- Voucher Promotion -->
          <div class="col-6 col-md-2 font-size-medium">
            <button
              :class="['btn text-white my-2 my-sm-0 btn-sm w-100 cursor-pointer', this.selected == VoucherType.PROMOTION ? 'bg-button-primary' : 'bg-button-outline-primary']"
              type="submit"
              style="display: flex; align-items: center;"
              @click="selectBtnStatus(VoucherType.PROMOTION)"
            >
              <div style="width: 100%;">
                {{ $t('evoucher.promotion') }}
              </div>
              <div v-if="forConasi" style="text-align: right; float: right; width: 100%;">
                <img style="width: 20px; height: 20px;" src="../../assets/promotion_voucher_icon.png" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;"></div>
    <div class="container-fluid">
      <div v-if="!forConasi" class="divider-text bg-light" />
      <div style="text-align: right;" class="mt-4" v-if="voucherSelectedId.length > 0">
        <button style="text-align: right;" type="button" class="btn btn-primary" data-dismiss="modal" @click="onAssignEVoucher($event, voucherSelected, VoucherTransactionType.MULTIPLE)">{{ $t('transactionBetweenCustomer.transactionMulti') }}</button>
      </div>
      <div v-if="voucherList.length > 0" class="row">
        <div
          class="col-6 col-md-4 font-size-medium mt-4"
          v-for="(voucher, index) in voucherList"
          :key="voucher + index"
          style="cursor: pointer; position: relative;"
        >
          <div style="cursor: pointer; position: absolute; right: 30px; z-index: 999;" v-if="voucher.status != VoucherStatusType.USED && voucher.status != VoucherStatusType.WAITING && voucher.issuanceType != issuanceType.PROMOTION && selected != VoucherType.VOUCHER_TRANSFERRED">
            <input type="checkbox" class="form-check-input filled-in" :value="voucher.id" :id="voucher.id" v-model="voucherSelectedId" style="width: 30px; height: 20px;">
          </div>
          <div @click="onShowVoucherInfo(voucher)" data-toggle="modal" data-target="#exampleModal" style="height: 100%">
            <voucherCard :voucher="voucher" :isTranferred="selected == VoucherType.VOUCHER_TRANSFERRED" />
          </div>
        </div>
      </div>
      <div v-else-if="!forConasi" class="text-center mt-5">
        <img src="../../assets/help-icon-00.png" />
        <div class="mt-3 pb-5">
          <span>{{ $t('voucherManagement.noVoucher') }}</span>
        </div>
      </div>
      <!--  -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div :class="['modal-dialog modal-dialog-centered', 'modal-lg']" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div v-if="voucherSelected">
                <voucherDetail
                  :voucher="voucherSelected"
                  :isTranferred="selected == VoucherType.VOUCHER_TRANSFERRED"
                  :isShowBtnAction="true"
                  :isShowActiveCode="true"
                  @doAssignVoucher="onAssignEVoucher($event, voucherSelected, VoucherTransactionType.SINGLE)"
                  @doConfirmUsedVoucher="onConfirmUsedVoucher($event, voucherSelected)"
                />
              </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="onAssignEVoucher($event, voucherSelected)">Send message</button>
            </div> -->
          </div>
        </div>
      </div>
      <!--  -->
      <paginate
        v-show="voucherList.length > 0"
        :rows="paginator.totalPage"
        :per-page="paginator.perPage"
        :current-page="paginator.currentPage"
        :total-item="paginator.count"
        @onPageChange="pageChange"
      />
    </div>
    <loadingBar v-show="isLoading" :useSlot="true" :isLoading="isLoading" />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/vi";
import functionUtils from "Utils/functionUtils";
import { mapActions, mapGetters } from "vuex";
import EntityType from "Enum/entityType";
import Enum from "Enum/enum";
import dateUtils from "Utils/dateUtils";
import stringUtils from "Utils/stringUtils";
import { FOR_CONASI_TARGET } from 'Utils/constants'
import VoucherStatusType from "Enum/voucherStatusType";
import { isCookieEnabled, getCookie } from 'tiny-cookie'
import VoucherTransactionType from 'Enum/voucherTransactionType'
import VoucherIssuanceType from 'Enum/voucherIssuanceType'
import VoucherType from 'Enum/voucherType'
import voucherDetail from './VoucherDetail'
import voucherCard from './VoucherCard'
export default {
  components: {
    DatePicker,
    voucherDetail,
    voucherCard
  },
  props: {
  },
  data: () => ({
    forConasi: FOR_CONASI_TARGET,
    format: "DD/MM/YYYY",
    startDate: null,
    endDate: null,
    selected: VoucherType.VOUCHER_NOT_USE_YET,
    paginator: {
      count: 0,
      currentPage: 1,
      totalPage: 1,
      rowPerPage: 1,
    },
    voucherList: [],
    isLoading: false,
    voucherTypeList: stringUtils.VoucherTypeList,
    issuanceType: Enum.issuanceType,
    voucherSelected: null,
    voucherSelectedId: [],
    VoucherTransactionType: VoucherTransactionType,
    VoucherIssuanceType: VoucherIssuanceType,
    VoucherStatusType: VoucherStatusType,
    VoucherType: VoucherType,
    supplier: {
      list: [],
      id: null
    }
  }),
  computed: {
    ...mapGetters(["E_VOUCHER_DATA", "VOUCHER_HISTORY_DATA", "GET_CURRENT_ACCOUNT", "SUPPLIER_BY_VOUCHER_OF_CUSTOMER_DATA", "VOUCHER_PROMOTION_LIST_DATA"]),
  },
  watch: {
    E_VOUCHER_DATA() {
      let res = this.E_VOUCHER_DATA
      // Handle paginate
      this.paginator.count = res.paginate.count;
      this.paginator.currentPage = res.paginate.currentPage;
      this.paginator.totalPage = res.paginate.totalPage;
      this.paginator.rowPerPage = res.paginate.perPage / 2;
      // Handle response data
      let voucherData = res.results;
      this.voucherList = [];
      for (let i = 0, size = voucherData.length; i < size; i++) {
        let voucherObj = {
          id: voucherData[i].id,
          serial: voucherData[i].serial,
          status: voucherData[i].status,
          expiredDate: this.getStartDateEVoucher(voucherData[i].expired_date),
          value: voucherData[i].workpiece ? voucherData[i].workpiece.value : 0,
          description: voucherData[i].workpiece.description,
          workpiece: voucherData[i].workpiece,
          activeCode: voucherData[i].activation_code,
          fromEntity: voucherData[i].from_entity,
          issuanceType: voucherData[i].workpiece.type,
          ownerVoucher: voucherData[i].owner_voucher,
          activeCodeQr: voucherData[i].activation_code_qr,
          toUserTransferred: voucherData[i].to_user_transferred,
          issuanceImage: voucherData[i].workpiece.image_url,
          conditionsOfUse: voucherData[i].workpiece.conditions_of_use,
          details: voucherData[i].workpiece.details,
          usageSites: voucherData[i].usage_sites,
          isHidePrice: voucherData[i].workpiece.is_hide_price
        };
        this.voucherList.push(voucherObj);
      }
    },
    SUPPLIER_BY_VOUCHER_OF_CUSTOMER_DATA() {
      let data = this.SUPPLIER_BY_VOUCHER_OF_CUSTOMER_DATA
      this.supplier.list = [{ text: 'common.chooseAll', value: null }]
      for (let i = 0, size = data.length; i < size; i++) {
        let obj = {
          value: data[i].id,
          text: data[i].name
        }
        this.supplier.list.push(obj)
      }
    },
    VOUCHER_PROMOTION_LIST_DATA () {
      let res = this.VOUCHER_PROMOTION_LIST_DATA
      // Handle paginate
      this.paginator.count = res.paginate.count;
      this.paginator.currentPage = res.paginate.currentPage;
      this.paginator.totalPage = res.paginate.totalPage;
      this.paginator.rowPerPage = res.paginate.perPage / 2;
      // Handle response data
      let voucherData = res.results
      this.voucherList = []
      for (let i = 0, size = voucherData.length; i < size; i ++) {
        let voucherObj = {
          id: voucherData[i].id,
          value: voucherData[i].value,
          name: voucherData[i].name,
          remainQuantity: voucherData[i].remain_quantity,
          issuanceType: voucherData[i].type,
          owner: voucherData[i].owner,
          serial: voucherData[i].activation_code,
          codeQr: voucherData[i].activation_code_qr,
          numberOfUsesPerPerson: voucherData[i].number_of_uses_per_person,
          expiredDate: this.formatDate(voucherData[i].end_date),
          issuanceImage: voucherData[i].image_url,
          description: voucherData[i].description,
          conditionsOfUse: voucherData[i].conditions_of_use,
          usageSites: voucherData[i].usage_sites
        }
        this.voucherList.push(voucherObj);
      }
    }
  },
  created() {
    const token = isCookieEnabled() ? getCookie("token") : null;
    if (!token) {
      this.$router.push({
          path: '/login'
      })
    }
    else {
      let routerQuery = this.$route.query

      this.supplier.id = routerQuery && routerQuery.supplier ? Number(routerQuery.supplier) : null
      this.startDate = routerQuery && routerQuery.fromDate ? routerQuery.fromDate : null
      this.endDate = routerQuery && routerQuery.toDate ? routerQuery.toDate : null
      this.selected = routerQuery && routerQuery.status ? Number(routerQuery.status) : VoucherType.VOUCHER_NOT_USE_YET

      this.getEVoucherList();
      this.GET_SUPPLIER_BY_VOUCHER_OF_CUSTOMER()
    }
  },
  methods: {
    /**
     * Format date with timezone to format DD/MM/YYYY
     */
    formatDate: function (date) {
      return date ? dateUtils.formatDate(
          date,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        ) : ''
    },
    /**
     * Select status
     */
    selectBtnStatus: function (status) {
      this.selected = status
      this.onSearch()
    },
    /**
     * Get status
     */
    getStatus: function(status) {
      return functionUtils.getVoucherStatusText(status)
    },
    /**
     * Page change
     */
    pageChange: function(page) {
      this.paginator.currentPage = page;
      if (this.selected == VoucherType.PROMOTION) {
        this.getEVoucherPromotionList()
      } else {
        this.getEVoucherList()
      }
    },
    /**
     * Search
     */
    onSearch: function() {
      this.paginator.currentPage = 1
      this.$router.replace({
        query: {
          supplier: this.supplier.id,
          fromDate: this.startDate,
          toDate: this.endDate,
          status: this.selected
        }
      })
      if (this.selected == VoucherType.PROMOTION) {
        this.getEVoucherPromotionList()
      } else {
        this.getEVoucherList()
      }
    },
    /**
     * Convert to money
     */
    convertToMoney: function(value) {
      return functionUtils.convertFormatNumberToMoney(value);
    },
    /**
     * Get start date e voucher
     */
    getStartDateEVoucher: function(date) {
      if (!functionUtils.isNull(date)) {
        return dateUtils.formatDate(
          date,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        );
      } else {
        return "";
      }
    },
    /**
     * Get e-Voucher promotion list
     */
    getEVoucherPromotionList: function () {
      let filter = {
        params: {
          page: this.paginator.currentPage,
          supplier: this.supplier.id
        }
      }
      this.voucherSelectedId = []
      this.isLoading = true;
      this.GET_E_VOUCHER_PROMOTION_LIST(filter).then(
        function () {
          this.isLoading = false
        }.bind(this)
      ).catch(
        function () {
          this.isLoading = false
        }.bind(this)
      )
    },
    /**
     * Get issue e voucher queue list
     */
    getEVoucherList: function() {
      let filter = {
        params: {
          page: this.paginator.currentPage,
          type: EntityType.CUSTOMER,
          startDate:
            this.startDate != null
              ? dateUtils.formatDate(
                  this.startDate,
                  dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
                  dateUtils.STATIC_FORMAT_DATE
                )
              : null,
          endDate:
            this.endDate != null
              ? dateUtils.formatDate(
                  this.endDate,
                  dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
                  dateUtils.STATIC_FORMAT_DATE
                )
              : null,
          status: this.selected,
          supplier: this.supplier.id
        },
      };
      this.voucherSelectedId = []
      this.isLoading = true;
      this.GET_E_VOUCHER_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onShowVoucherInfo: function (data) {
      this.voucherSelected = data
    },
    /**
     * Assign e voucher
     */
    onAssignEVoucher: function(event, eVoucher, type) {
      event.preventDefault();
      var footerText = ''
      if (type == VoucherTransactionType.SINGLE) {
        if (eVoucher.isHidePrice) {
          footerText = `<div style="display: flex; justify-content: space-around; width: 100%; text-align: center;"><span style="color: #A74528;">Mã: <span style="font-weight: bold;">${eVoucher.serial}</span></span><span style="color: #A74528;">Hạn sử dụng: <span style="font-weight: bold;">${eVoucher.expiredDate}</span></span></div>`
        } else {
          footerText = `<div style="display: flex; justify-content: space-around; width: 100%; text-align: center;"><span style="color: #A74528;">Mã: <span style="font-weight: bold;">${eVoucher.serial}</span></span><span style="color: #A74528;">${eVoucher.issuanceType == VoucherIssuanceType.PRICE ? 'Giá tiền' : 'Giảm'}: <span style="font-weight: bold;">${eVoucher.issuanceType == VoucherIssuanceType.PRICE ? this.convertToMoney(eVoucher.value) : eVoucher.value + '%'}</span></span><span style="color: #A74528;">Hạn sử dụng: <span style="font-weight: bold;">${eVoucher.expiredDate}</span></span></div>`
        }
      } else {
        footerText = `<div style="display: flex; justify-content: space-around; width: 100%; text-align: center;"><span>Từ: <span style="color: #A74528;">${this.GET_CURRENT_ACCOUNT.email}</span></span><span>Số lượng cần chuyển: <span style="color: #A74528;">${this.voucherSelectedId.length}</span></span></div>`
      }
      this.$swal.fire({
        title: 'Xác nhận chuyển E Voucher?',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        inputPlaceholder: 'Email',
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#A74528",
        confirmButtonText: 'Đồng ý',
        cancelButtonColor: "#d33",
        cancelButtonText: "Huỷ",
        showLoaderOnConfirm: true,
        footer: footerText,
        preConfirm: (email) => {
          if (email == null || email == undefined || email == "") {
            this.$swal.showValidationMessage('Vui lòng nhập email!')
            return
          }
          let filter = {
            type: type,
            voucherIds: this.voucherSelectedId,
            voucherId: eVoucher ? eVoucher.id : null,
            email: email.trim().toLowerCase(),
            customerUrl: stringUtils.DOMAIN_BASE_PATH
          };
          return this.TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER(filter).then(
            function(res) {
              this.$swal.fire({
                title: "Đã xác nhận!",
                confirmButtonColor: "#A74528",
                confirmButtonText: 'Đồng ý',
                text:"E Voucher của bạn đã được chuyển thành công.",
                icon: "success"
              });
              this.getEVoucherList();
              this.voucherSelectedId = []
              return res
            }.bind(this)
          ).catch(
            function (error) {
              let errorText = error.response.data.errorText
              if (!functionUtils.isNull(errorText)) {
                this.$swal.showValidationMessage(this.$t(errorText))
              } else {
                this.$swal.showValidationMessage('Có lỗi xảy ra!')
              }
            }.bind(this)
          )
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value) {
          this.getEVoucherList();
        }
      })
    },
    /**
     * On confirm used voucher
     */
    onConfirmUsedVoucher: function (event, eVoucher) {
      event.preventDefault()
      this.$swal.fire({
        title: 'Xác nhận sử dụng E Voucher?',
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#A74528",
        confirmButtonText: 'Đồng ý',
        cancelButtonColor: "#d33",
        cancelButtonText: "Huỷ",
        showLoaderOnConfirm: true,
        footer: `<div style="display: flex; justify-content: space-around; width: 100%; text-align: center;"><span style="color: #A74528;">Mã: <span style="font-weight: bold;">${eVoucher.serial}</span></span><span style="color: #A74528;">${eVoucher.issuanceType == VoucherIssuanceType.PRICE ? 'Giá tiền' : 'Giảm'}: <span style="font-weight: bold;">${eVoucher.issuanceType == VoucherIssuanceType.PRICE ? this.convertToMoney(eVoucher.value) : eVoucher.value + '%'}</span></span><span style="color: #A74528;">Hạn sử dụng: <span style="font-weight: bold;">${eVoucher.expiredDate}</span></span></div>`,
        preConfirm: () => {
          let filter = {
            status: this.VoucherStatusType.USED,
            voucherId: eVoucher ? eVoucher.id : null
          };
          return this.CUSTOMER_CONFIRM_USED_VOUCHER(filter).then(
            function(res) {
              this.$swal.fire({
                title: "Đã xác nhận!",
                confirmButtonColor: "#A74528",
                confirmButtonText: 'Đồng ý',
                text:"E Voucher của bạn đã được sử dụng thành công!",
                icon: "success"
              }).then((result) => {
                if (result.value) {
                  this.getEVoucherList();
                }
              })
              return res
            }.bind(this)
          ).catch(
            function (error) {
              let errorText = error.response.data.errorText
              if (!functionUtils.isNull(errorText)) {
                errorText = this.$t(errorText)
                this.$swal.showValidationMessage(errorText)
              } else {
                this.$swal.showValidationMessage('Có lỗi xảy ra!')
              }
            }.bind(this)
          )
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value) {
          this.getEVoucherList();
        }
      })
    },
    /**
     * Confirm used voucher promotion
     */
    onConfirmUsedVoucherPromotion: function (event, eVoucher) {
      event.preventDefault()
      this.$swal.fire({
        title: 'Xác nhận sử dụng E Voucher khuyến mãi?',
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#A74528",
        confirmButtonText: 'Đồng ý',
        cancelButtonColor: "#d33",
        cancelButtonText: "Huỷ",
        showLoaderOnConfirm: true,
        footer: `<div style="display: flex; justify-content: space-around; width: 100%; text-align: center;"><span style="color: #A74528;">Mã: <span style="font-weight: bold;">${eVoucher.serial}</span></span><span style="color: #A74528;">Giá tiền: <span style="font-weight: bold;">${this.convertToMoney(eVoucher.value)}</span></span><span style="color: #A74528;">Số lượng còn lại: <span style="font-weight: bold;">${eVoucher.remainQuantity}</span></span></div>`,
        preConfirm: () => {
          let filter = {
            workpieceId: eVoucher ? eVoucher.id : null
          };
          return this.USED_VOUCHER_PROMOTION(filter).then(
            function(res) {
              this.$swal.fire({
                title: this.$t('common.notificationToast.success'),
                confirmButtonColor: "#A74528",
                confirmButtonText: this.$t('common.agree'),
                text: this.$t('usedVoucherPromotion.yourPromotionalEVoucherHasBeenUsedSuccessfully'),
                icon: "success"
              }).then((result) => {
                if (result.value) {
                  this.getEVoucherPromotionList()
                }
              })
              return res
            }.bind(this)
          ).catch(
            function (error) {
              let errorText = error.response.data.errorText
              if (!functionUtils.isNull(errorText)) {
                errorText = this.$t(errorText)
                this.$swal.showValidationMessage(errorText)
              } else {
                this.$swal.showValidationMessage(this.$t('login.somethingWentWrong'))
              }
            }.bind(this)
          )
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value) {
          this.getEVoucherList();
        }
      })
    },
    ...mapActions(["GET_E_VOUCHER_LIST", 'TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER', 'CUSTOMER_CONFIRM_USED_VOUCHER', 'GET_SUPPLIER_BY_VOUCHER_OF_CUSTOMER', 'GET_E_VOUCHER_PROMOTION_LIST', 'USED_VOUCHER_PROMOTION']),
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.content-layout,
.content-layout-conasi {
  .form-panel {
    background-color: $bg-primary;
    border-radius: 1em;
    margin-bottom: .5em;
  }
  .container-fluid {
    background-color: white;
    border-radius: 1em;
    margin-bottom: 1em;
    padding-top: 1px;
  }
  .color-primary {
    color: $text-primary !important;
  }
  .bg-button-primary {
    background-color: $btn-background !important;
  }
  .bg-button-outline-primary {
    background-color: #fff !important;
    color: $primary !important;
  }
  .btn-search-mt {
    margin-top: 38px;
  }
}

.content-layout {
  .form-panel {
    background-color: whitesmoke;
    border-radius: 0;
    margin-bottom: 0;
  }
  .container-fluid {
    background-color: whitesmoke;
    border-radius: 0;
  }
  .color-primary {
    color: black !important;
  }
  .bg-button-outline-primary {
    background-color: transparent !important;
    color: $text-input-form !important;
  }
}

.divider-text {
  position: relative;
  text-align: center;
  margin: .5em 0 1em 0;
}
.divider-text:after {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 1px solid #ddd;
  top: 55%;
  left: 0;
  z-index: 1;
}

/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/

@media (min-width: 481px) and (max-width: 767px) {
  .btn-search-mt {
    margin-top: 0px !important;
  }
}
/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  .btn-search-mt {
    margin-top: 0px !important;
  }
}
</style>
